import { useEffect } from "react";
import { Box } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { useRecoilValue } from "recoil";
import {
  fundKRFeeState
} from "@states/fundKr";
import { CSToolbar } from '@components/grid/CSToolbar';
import { useOpenSnackbar } from "@hooks/useSnackbar";

export default function Summary() {
  const feeData = useRecoilValue(fundKRFeeState);
  const openSnackbar = useOpenSnackbar();

  // 보수 이력이 0행인 펀드는 탭 자체가 막혀 있어서(Tabs/index.tsx) 여기까지 오지
  // 않는다. 여기로 올 수 있는 '빈 화면' 은 조회가 실패해서 selector 가 undefined
  // 를 돌려준 경우뿐이다. 형제 패널(UndlPanel)과 같은 문구로 알린다.
  useEffect(() => {
    if (!feeData) {
      openSnackbar("데이터가 없습니다. 😰", "error");
    }
  }, [feeData, openSnackbar]);

  if (!feeData) {
    return <></>
  }

  const {columns } = feeData;

  const portColums = columns.map((portName) => ({
    field: portName, 
    width: 150,
    align:"right"
  }));

  const overviewColumns = [
    { field: "base_dt", headerName: "날짜", width: 150},
    ...portColums,
  ];

  return (
    <Box sx={{ height: 500, m: 0, my: 2 }}>
      <DataGridPro
        components={{ Toolbar: CSToolbar }}
        columns={overviewColumns}
        rows={feeData?.rows ?? []}
        density="compact"
        disableSelectionOnClick
        getRowId={(row) => row.base_dt}
        hideFooter
        // 탭이 막히기 전 한순간이나 예상 못한 경로로 들어왔을 때를 위해 남겨둔다.
        localeText={{ noRowsLabel: "이 펀드는 보수 데이터가 없습니다." }}
      />
    </Box>
  );
}
